/**
* 监测数据实时推送
*/
const measuringServer = {
  
allotMeasuringRealtimeNotifyServer: "/api/allotMeasuringRealtimeNotifyServer",//分配（获取）一个监测数据实时推送服务器
}

export default measuringServer